import { TEditSubCategoryAction, EditSubCategoryActionTypes } from './editSubCategoryActions';
import { IEditSubCategoryState } from './editSubCategoryContext';

export const editSubCategoryReducer = (
	state: IEditSubCategoryState,
	action: TEditSubCategoryAction,
): IEditSubCategoryState => {
	switch (action.type) {
		case EditSubCategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditSubCategoryActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditSubCategoryActionTypes.SET_ALL_DATA:
			return {
				...state,
				subCategoryID: action.payload.subCategoryID,
				initialIDSelectedCategory: action.payload.initialIDSelectedCategory,
				initialNameSelectedCategory: action.payload.initialNameSelectedCategory, // If they make category selection active then remove that.
				filePath: action.payload.filePath,
				preSignedUrl: action.payload.preSignedUrl,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				nameOfSubCategory: action.payload.nameOfSubCategory,
				initialIDsOfRestaurantsWhereToHide: action.payload.initialIDsOfRestaurantsWhereToHide,
				initialIDsOfRestaurantsAvailableForRepetition:
					action.payload.initialIDsOfRestaurantsAvailableForRepetition,
				dishesOfSubcategory: action.payload.dishesOfSubcategory,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				translations: action.payload.translations,
			};
		case EditSubCategoryActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditSubCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditSubCategoryActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditSubCategoryActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditSubCategoryActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case EditSubCategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				IDsOfRestaurantsWhereToHide: [],
				IDsOfRestaurantsAvailableForRepetition: [],
				defaultCustomerLanguage: null,
			};
		case EditSubCategoryActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case EditSubCategoryActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				IDsOfRestaurantsWhereToHide: action.payload.IDsOfRestaurantsWhereToHide,
				IDsOfRestaurantsAvailableForRepetition: action.payload.IDsOfRestaurantsAvailableForRepetition,
			};
		case EditSubCategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY:
			return {
				...state,
				nameOfSubCategory: action.payload.nameOfSubCategory,
			};
		case EditSubCategoryActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.categories,
			};
		case EditSubCategoryActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
			};
		case EditSubCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditSubCategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditSubCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditSubCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditSubCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditSubCategoryActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE:
			return {
				...state,
				IDsOfRestaurantsWhereToHide: action.payload.IDsOfRestaurantsWhereToHide,
			};
		case EditSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION:
			return {
				...state,
				IDsOfRestaurantsAvailableForRepetition: action.payload.IDsOfRestaurantsAvailableForRepetition,
			};
		case EditSubCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditSubCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditSubCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				filePath: null,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				nameOfSubCategory: '',
				fetchedCategories: [],
				IDSelectedCategory: null,
				IDsOfRestaurantsWhereToHide: [],
				IDsOfRestaurantsAvailableForRepetition: [],
				activationSchedule: '',
				deactivationSchedule: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
				errorResponseData: null,
			};
		default:
			return state;
	}
};
